import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';

export const breakReasonStart = () => {
  return {
    type: actionTypes.BREAK_REASON_START,
  };
};

export const breakReasonFail = (error) => {
  return {
    type: actionTypes.BREAK_REASON_FAIL,
    error: error,
  };
};

export const breakReasonSuccess = (breakReasons) => {
  return {
    type: actionTypes.BREAK_REASON_SUCCESS,
    breakReasons: breakReasons,
  };
};

export const breakReason = (agentId) => {
  return (dispatch) => {
    dispatch(breakReasonStart());
    ctiRequest['CTI_BREAK_REASON'].agent_id = agentId;
    ctiRequest['CTI_BREAK_REASON'].ip = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    axios
      .post('/', ctiRequest['CTI_BREAK_REASON'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(breakReasonSuccess(result.data.response.break_reasons));
        } else {
          dispatch(breakReasonFail(result.data.response.reason));
          //console.log(result.data.response.reason);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(breakReasonFail(err));
      });
  };
};